module.exports = __webpack_public_path__ + "static/dansesuisse-23fb667d14ecf28e8b98321bdfc79705.jpg";